<div class="bot-page-main">
  <app-header-bot></app-header-bot>

  <div class="bot-container">

    <div class="page-title-wrapper">
      <h4 class="page-title">CRED Guru Bot</h4>
    </div>

    <div class="bot-split-row">

      <div class="bot-box-side-panel">
        <app-guruOrderbook></app-guruOrderbook>
      </div>
      <div class="bot-box-chart">
        <div class="botChart">
          <app-chart *ngIf="chartStatus" class="trade_chart baseblock_wrapper" [chartData]="chartData"></app-chart>
        </div>
      </div>

      <div class="bot-box-side-panel">
        <app-guruOpenPosition></app-guruOpenPosition>
      </div>

    </div>

    <div class="bot-middle-row">
      <app-adminBotGuruTopGainer></app-adminBotGuruTopGainer>
    </div>

    <div class="bot-history">
      <app-GuruOrderHistory (botSelected)="onBotSelected($event)">
      </app-GuruOrderHistory>
    </div>

  </div>
</div>